import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    EN: {
      translation: {
        ourMenus: "Our Menus",
        viewPdf: "View PDF",
        westernMenu: "Western Menu",
        canapeMenu: "Canape Menu",
        chineseMenu: "Chinese Menu",
        vegeMenu: "Vegetarian Menu",
        banner: {
          title: "“Your Trusted Catering & Event Partner in Klang Valley.”",
          subtitle: "We provide catering and buffet services, canopy setup, and event management — specializing in Klang Valley areas.",
          button: "Explore Our Menus"
        },
        services: {
          sectionTitle: "Our Services",
          catering: {
            title: "Catering",
            desc: "Full-service catering for weddings, corporate events, and private parties."
          },
          customMenus: {
            title: "Custom Menus",
            desc: "Tailored menus to fit your event theme, dietary needs, and preferences."
          },
          decorations: {
            title: "Decorations",
            desc: "Elegant and creative decor setup to match your event’s atmosphere."
          },
          canopySetup: {
            title: "Canopy Setup",
            desc: "Professional canopy and tent setup for outdoor functions and celebrations."
          }
        },
        whatsappMessage: "Hello! Can I get more info on your catering service?",
        gallery: {
          title: "Gallery"
        },
       about: {
          main: `<b>Imperial Caterer</b> delivers memorable culinary experiences for every occasion across <b>Klang Valley</b>, <b>Seremban</b>, and <b>Genting Sempah</b>.<br/>
            Weddings, corporate events, private gatherings—<br/>
            <b>we make it special, every time.</b><br/><br/>
            <span style="color:var(--color-brand);"><b>Need catering on short notice? We accept urgent and last-minute orders!</b></span>`,
          sectionTitle: "About Us",
          emailBtn: "📧 Email Us: {{email}}",
          mapCaption: "Serving the Klang Valley, Seremban, & Genting Sempah"
        },
        reviews: {
          title: "What People Said"
        },
      }
    },
    CN: {
      translation: {
        ourMenus: "我们的菜单",
        viewPdf: "查看 PDF",
        westernMenu: "西式菜单",
        canapeMenu: "小吃菜单",
        chineseMenu: "中式菜单",
        vegeMenu: "素食菜单",
        banner: {
          title: "“您在雪隆区值得信赖的餐饮与活动合作伙伴。”",
          subtitle: "我们专注于雪隆地区，提供专业的餐饮与自助餐服务、帐篷搭建及活动管理。",
          button: "查看我们的菜单"
        },
        services: {
          sectionTitle: "我们的服务",
          catering: {
            title: "餐饮服务",
            desc: "为婚礼、公司活动和私人聚会提供全方位餐饮服务。"
          },
          customMenus: {
            title: "定制菜单",
            desc: "根据您的活动主题和饮食需求量身定制菜单。"
          },
          decorations: {
            title: "场地布置",
            desc: "优雅且富有创意的布置，营造理想的氛围。"
          },
          canopySetup: {
            title: "帐篷搭建",
            desc: "专业的帐篷与篷布搭建服务，适合户外活动。"
          }
        },
        whatsappMessage: "你好！我可以了解更多关于你们餐饮服务的信息吗？",
        gallery: {
          title: "画廊"
        },
        about: {
           main: `<b>御膳房 Imperial Caterer</b> 致力于为您在 <b>巴生谷</b>、<b>芙蓉</b> 及 <b>云顶森帕</b> 的每一个重要场合提供难忘的美食体验。<br/>
            婚礼、公司活动、私人聚会——<br/>
            <b>每一次，我们都让它与众不同。</b><br/><br/>
            <span style="color:var(--color-brand);"><b>临时有需要？我们接受紧急与最后时刻的订餐！</b></span>`,
          sectionTitle: "关于我们",
          emailBtn: "📧 电邮我们：{{email}}",
          mapCaption: "服务范围涵盖吉隆坡与雪兰莪"
        },
        reviews: {
          title: "客户评价"
        },
      }
    },
    BM: {
      translation: {
        ourMenus: "Menu Kami",
        viewPdf: "Lihat PDF",
        westernMenu: "Menu Barat",
        canapeMenu: "Menu Canape",
        chineseMenu: "Menu Cina",
        banner: {
          title: "“Rakan Katering & Acara Dipercayai Anda di Lembah Klang.”",
          subtitle: "Kami menyediakan perkhidmatan katering dan bufet, pemasangan kanopi, dan pengurusan acara — khusus di kawasan Lembah Klang.",
          button: "Lihat Menu Kami"
        },
        services: {
          sectionTitle: "Perkhidmatan Kami",
          catering: {
            title: "Katering",
            desc: "Perkhidmatan katering penuh untuk majlis perkahwinan, acara korporat, dan majlis persendirian."
          },
          customMenus: {
            title: "Menu Tersuai",
            desc: "Menu yang disesuaikan mengikut tema acara dan keperluan diet anda."
          },
          decorations: {
            title: "Dekorasi",
            desc: "Penyediaan hiasan yang elegan dan kreatif untuk suasana acara anda."
          },
          canopySetup: {
            title: "Pemasangan Kanopi",
            desc: "Pemasangan kanopi dan khemah profesional untuk majlis luar."
          }
        },
        whatsappMessage: "Hello! Boleh saya dapatkan maklumat lanjut tentang perkhidmatan katering anda?",
        gallery: {
          title: "Galeri"
        },
        about: {
           main: `<b>Imperial Caterer</b> menawarkan pengalaman kulinari yang tidak dapat dilupakan untuk setiap majlis di <b>Lembah Klang</b>, <b>Seremban</b> dan <b>Genting Sempah</b>.<br/>
            Majlis perkahwinan, acara korporat, atau majlis peribadi—<br/>
            <b>kami pastikan segalanya istimewa, setiap masa.</b><br/><br/>
            <span style="color:#0077B6;"><b>Perlu katering segera? Kami terima tempahan kecemasan & saat akhir!</b></span>`,
          sectionTitle: "Tentang Kami",
          emailBtn: "📧 Emel Kami: {{email}}",
          mapCaption: "Kami berkhidmat di seluruh Kuala Lumpur & Selangor"
        },
        reviews: {
          title: "Kata Mereka"
        },
      }
    }
  },
  lng: "EN", // default language
  fallbackLng: "EN",
  interpolation: {
    escapeValue: false,
  }
});

export default i18n;